import * as z from 'zod';

const AddressSchema = z.object({
  postcode: z.string(),
  addline1: z.string(),
  addline2: z.string().optional(),
  addline3: z.string().optional(),
  addline4: z.string().optional(),
  region: z.string().optional(),
  country: z.string().optional()
});

export const LabTestSchema = z.object({
  labs: z.array(
    z.object({
      appt_completed_date: z.date().nullable(),
      appt_id: z.number(),
      case_id: z.number(),
      // a.k.a. the case ref!
      client_case_id: z.string(),
      ext_order_id: z.string().nullable(),
      full_name: z.string(),
      urg_code: z.string(),
      urg_desc: z.string(),
      has_img_reqs: z.boolean(),
      geninv_status_desc: z.string().nullable(),
      lab_test_status_code: z.union([
        z.literal('NEW_ORDER'),
        z.literal('RAND_INCOMPLETE'),
        z.literal('RAND_SUBMIT'),
        z.literal('RAND_PENDING'),
        z.literal('RAND_COMPLETE'),
        z.literal('RAND_CANCELLED'),
        z.literal('TRACKING_ERROR'),
        z.literal('IR_BOOKED'),
        z.literal('AUTHGRANTED'),
        z.literal('ORDER_TBC'),
        z.literal('REMINDER_SENT'),
        z.literal('NOT_SUITABLE'),
        z.literal('PARTIAL_RESULTS'),
        z.literal('DISPATCH_PEND'),
        z.literal('IR_PENDING')
      ]),
      lab_tests: z.array(
        z.object({
          lab_test_id: z.number(),
          service_cat_code: z.string(),
          service_cat_desc: z.string(),
          service_type_code: z.string(),
          service_type_desc: z.string(),
          randox_code: z.string().optional(),
          urine_test: z.coerce.boolean()
        })
      ),
      lucy_id: z.string(),
      randox_status_id: z.string().nullable(),
      user_guid: z.string(),
      patient_address: AddressSchema,
      order_address: AddressSchema.partial().nullable(),
      order_route_desc: z.string().nullable(),
      order_route_code: z.string().nullable(),
      home_kit_order: z.union([z.literal(0), z.literal(1)]),
      in_person_order: z.union([z.literal(0), z.literal(1)]),
      tracking_id: z.string().optional().nullable(),
      tracking_info: z.object({
        courier_name: z.string().optional(),
        dispatch_id: z.string().optional(),
        internal_kit_order_id: z.string().optional(),
        p_urn_list: z.string().optional(),
        tracking_id: z.string().optional()
      }),
      results_received_date: z.date().nullable(),
      can_remove_order: z.boolean(),
      order_chase_count: z.number().nullable(),
      order_chasable: z.boolean(),
      randox_order_json: z.string().nullable(),
      inuvi_exam_id: z.string().nullable(),
      lab_test_provider_code: z.string().nullable(),
      lab_test_provider_desc: z.string().nullable(),
      ext_appt_date: z.date().nullable()
    })
  )
});

export type LabTests = z.infer<typeof LabTestSchema>;
export type LabTest = LabTests['labs'][number];
export type LabTestStatus = LabTest['lab_test_status_code'];
